"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schoolSearch = void 0;
/* ========================================================================
    Module: School search
 ========================================================================== */
const axios_1 = require("axios");
const axios_2 = require("~modules/axios");
const util_1 = require("~modules/util");
const endpointUrlBase = `${laravel.url}/api/school-search`;
let schools = [];
/**
 * 学校情報を検索する
 *
 * @returns {void}
 */
const schoolSearch = () => {
    const applicationCategorySelectors = document.querySelectorAll(".js-application-category-selector");
    const postCodeElement = document.querySelector(".js-school-search-post-code");
    const prefecturesElement = document.querySelector(".js-school-search-prefectures");
    const addressElement = document.querySelector(".js-school-search-address");
    const schoolInputSelector = document.querySelectorAll(".js-school-input-selector");
    const autoFillButton = document.querySelector(".js-school-search-auto-fill-button");
    const schoolNameSelector = document.querySelector(".js-school-search-school-name");
    const conditions = {
        application_category: "",
        post_code: "",
        prefectures: "",
        address: "",
    };
    if (schoolInputSelector.length === 0) {
        return;
    }
    // 初期表示
    if (inputValueRadio(schoolInputSelector) === laravel.schoolInputTypes.search) {
        conditions.application_category = inputValueRadio(applicationCategorySelectors);
        conditions.post_code = inputValue(postCodeElement);
        conditions.prefectures = inputValue(prefecturesElement);
        conditions.address = inputValue(addressElement);
        search(conditions, true);
        // 住所を編集不可にする
        if (schoolNameSelector && addressElement) {
            if (schoolNameSelector.dataset.schoolIdOld) {
                addressElement.readOnly = true;
            }
        }
    }
    // カテゴリー選択のラジオボタンにイベントリスナーを設定する
    if (applicationCategorySelectors.length > 0) {
        applicationCategorySelectors.forEach((element) => {
            element.addEventListener("change", (e) => {
                if (inputValueRadio(schoolInputSelector) !==
                    laravel.schoolInputTypes.search) {
                    return;
                }
                conditions.application_category = inputValueRadio(applicationCategorySelectors);
                conditions.post_code = inputValue(postCodeElement);
                conditions.prefectures = inputValue(prefecturesElement);
                conditions.address = inputValue(addressElement);
                // 学校名をリセットする
                if (schoolNameSelector) {
                    schoolNameSelector.dataset.schoolIdOld = "";
                }
                search(conditions);
                // 住所を編集可能にする
                if (addressElement) {
                    addressElement.readOnly = false;
                }
                // 学校名をリセットする
                if (schoolNameSelector) {
                    schoolNameSelector.value = "";
                }
            });
        });
    }
    // 郵便番号のテキストボックスにイベントリスナーを設定する
    postCodeElement?.addEventListener("change", (e) => {
        if (inputValueRadio(schoolInputSelector) !== laravel.schoolInputTypes.search) {
            return;
        }
        conditions.application_category = inputValueRadio(applicationCategorySelectors);
        conditions.post_code = inputValue(postCodeElement);
        conditions.prefectures = inputValue(prefecturesElement);
        conditions.address = inputValue(addressElement);
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.dataset.schoolIdOld = "";
        }
        search(conditions);
        // 住所を編集可能にする
        if (addressElement) {
            addressElement.readOnly = false;
        }
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.value = "";
        }
    });
    // 都道府県のプルダウンににイベントリスナーを設定する
    prefecturesElement?.addEventListener("change", (e) => {
        if (inputValueRadio(schoolInputSelector) !== laravel.schoolInputTypes.search) {
            return;
        }
        conditions.application_category = inputValueRadio(applicationCategorySelectors);
        conditions.post_code = inputValue(postCodeElement);
        conditions.prefectures = inputValue(prefecturesElement);
        conditions.address = inputValue(addressElement);
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.dataset.schoolIdOld = "";
        }
        search(conditions);
        // 住所を編集可能にする
        if (addressElement) {
            addressElement.readOnly = false;
        }
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.value = "";
        }
    });
    // 住所のテキストボックスにイベントリスナーを設定する
    addressElement?.addEventListener("change", (e) => {
        if (inputValueRadio(schoolInputSelector) !== laravel.schoolInputTypes.search) {
            return;
        }
        conditions.application_category = inputValueRadio(applicationCategorySelectors);
        conditions.post_code = inputValue(postCodeElement);
        conditions.prefectures = inputValue(prefecturesElement);
        conditions.address = inputValue(addressElement);
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.dataset.schoolIdOld = "";
        }
        search(conditions);
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.value = "";
        }
    });
    // 自動入力はイベントが発火しないので強制的に発火する
    autoFillButton?.addEventListener("click", async (e) => {
        // AjaxZip3 よりも先に処理が走るようなので少し待たせる
        await (0, util_1.wait)(200);
        if (inputValueRadio(schoolInputSelector) !== laravel.schoolInputTypes.search) {
            return;
        }
        conditions.prefectures = inputValue(prefecturesElement);
        conditions.address = inputValue(addressElement);
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.dataset.schoolIdOld = "";
        }
        search(conditions);
        // 住所を編集可能にする
        if (addressElement) {
            addressElement.readOnly = false;
        }
        // 学校名をリセットする
        if (schoolNameSelector) {
            schoolNameSelector.value = "";
        }
    });
    // 学校名のプルダウンにイベントリスナーを設定する
    schoolNameSelector?.addEventListener("change", (e) => {
        if (!(e.currentTarget instanceof HTMLSelectElement)) {
            return;
        }
        const target = e.currentTarget;
        if (inputValueRadio(schoolInputSelector) !==
            laravel.schoolInputTypes.search ||
            schools.length === 0) {
            return;
        }
        const selectedSchool = schools.find((school) => {
            return school.id === parseInt(target.value);
        });
        if (selectedSchool) {
            if (postCodeElement) {
                postCodeElement.value = selectedSchool.post_code;
            }
            if (prefecturesElement && selectedSchool.prefecture?.id) {
                prefecturesElement.value = String(selectedSchool.prefecture.id);
            }
            if (addressElement) {
                addressElement.value = selectedSchool.address ?? "";
                // 住所を編集不可にする
                addressElement.readOnly = true;
            }
        }
    });
};
exports.schoolSearch = schoolSearch;
/**
 * 学校情報を検索する
 *
 * @param {ConditionsType} conditions
 * @param {boolean} isLoad
 * @returns {void}
 */
const search = (conditions, isLoad = false) => {
    const schoolNameSelector = document.querySelector(".js-school-search-school-name");
    if (!schoolNameSelector) {
        return;
    }
    const params = new URLSearchParams(conditions);
    let schoolIdOld = null;
    if (schoolNameSelector.dataset.schoolIdOld) {
        schoolIdOld = schoolNameSelector.dataset.schoolIdOld;
    }
    schoolNameSelector.disabled = true;
    axios_2.appAxios
        .get(`${endpointUrlBase}?${params}`)
        .then((response) => {
        const schoolOptions = response.data.data;
        schoolNameSelector.innerHTML = `<option value="" disabled${!schoolIdOld ? " selected" : ""}></option>`;
        schools = schoolOptions;
        schoolOptions.forEach((school) => {
            schoolNameSelector.insertAdjacentHTML("beforeend", `<option value="${school.id}"${schoolIdOld === school.id.toString() ? " selected" : ""}>${(0, util_1.esc_html)(school.school_name)}</option>`);
        });
        customSchoolNameSelector(schoolNameSelector, isLoad, conditions);
    })
        .catch((errors) => {
        if (errors.response) {
            // HTTPエラー
            alert(`${errors.response.data.message}\nお手数をおかけいたしますが、再度お申し込みし直していただけますようお願いいたします。`);
            // タイムアウト
        }
        else if (errors.code === axios_1.AxiosError.ECONNABORTED) {
            alert("処理の実行中にタイムアウトが発生しました。");
            // 通信失敗
        }
        else {
            alert(errors.message);
        }
    })
        .finally(() => {
        schoolNameSelector.disabled = false;
    });
};
/**
 * 学校名フィールドのプルダウンをカスタマイズ
 *
 * @param {HTMLSelectElement} schoolNameSelector
 * @param {boolean} isLoad
 * @param {ConditionsType} conditions
 * @returns {void}
 */
const customSchoolNameSelector = (schoolNameSelector, isLoad, conditions) => {
    const originOptions = [...schoolNameSelector.children];
    const selectedElement = document.querySelector(".js-searched-school-selected");
    if (!selectedElement) {
        return;
    }
    const filteredOriginOptions = originOptions.filter((option) => {
        return option instanceof HTMLOptionElement && option.value !== "";
    });
    selectedElement.innerText = "";
    selectedElement.removeEventListener("click", handleClickSelectedElement);
    selectedElement.addEventListener("click", handleClickSelectedElement);
    const optionsExistElement = selectedElement.parentNode?.querySelector(".searched-school-selector__options");
    if (optionsExistElement) {
        optionsExistElement.remove();
    }
    const optionsElement = document.createElement("ul");
    optionsElement.classList.add("searched-school-selector__options");
    selectedElement.parentNode?.insertBefore(optionsElement, selectedElement.nextElementSibling);
    originOptions.forEach((option, index) => {
        if (!(option instanceof HTMLOptionElement) || option.value === "") {
            return;
        }
        const listElement = document.createElement("li");
        listElement.textContent = option.textContent;
        listElement.setAttribute("rel", option.value);
        if (schoolNameSelector.selectedIndex === index) {
            listElement.classList.add("is-selected");
            selectedElement.innerText = listElement.textContent || "";
        }
        listElement.addEventListener("click", (e) => {
            e.stopPropagation();
            if (!(e.currentTarget instanceof HTMLElement)) {
                return;
            }
            selectedElement.innerText = e.currentTarget.textContent || "";
            selectedElement.classList.remove("is-active");
            schoolNameSelector.value = e.currentTarget.getAttribute("rel") || "";
            const selectedItem = optionsElement.querySelector(".is-selected");
            selectedItem?.classList.remove("is-selected");
            e.currentTarget.classList.add("is-selected");
            optionsElement.style.display = "none";
            // 学校名のプルダウンのイベントを発火する
            schoolNameSelector.dispatchEvent(new Event("change"));
        });
        optionsElement.appendChild(listElement);
    });
    if (!isLoad) {
        if (filteredOriginOptions.length > 0) {
            selectedElement.innerText = "お選びください";
            optionsElement.style.display = "block";
        }
        else if (conditions.post_code ||
            conditions.prefectures ||
            conditions.address) {
            selectedElement.innerText = "該当なし";
        }
    }
    document.removeEventListener("click", handleClickDocument);
    document.addEventListener("click", handleClickDocument);
};
/**
 * 学校名フィールドのクリックイベントハンドラー
 *
 * @param {MouseEvent} e
 * @returns {void}
 */
const handleClickSelectedElement = (e) => {
    e.stopPropagation();
    if (!(e.currentTarget instanceof HTMLDivElement)) {
        return;
    }
    const optionsElement = e.currentTarget.parentNode?.querySelector(".searched-school-selector__options");
    if (!optionsElement) {
        return;
    }
    if (e.currentTarget.classList.contains("is-active")) {
        e.currentTarget.classList.remove("is-active");
        optionsElement.style.display = "none";
    }
    else {
        e.currentTarget.classList.add("is-active");
        optionsElement.style.display = "block";
    }
};
/**
 * 他の場所のクリックイベントハンドラー
 *
 * @param {MouseEvent} e
 * @returns {void}
 */
const handleClickDocument = (e) => {
    e.stopPropagation();
    const selectedElement = document.querySelector(".js-searched-school-selected");
    if (selectedElement) {
        selectedElement.classList.remove("is-active");
        const optionsElement = selectedElement.parentNode?.querySelector(".searched-school-selector__options");
        if (optionsElement) {
            optionsElement.style.display = "none";
        }
    }
};
/**
 * 入力値を取得する（ラジオボタン以外）
 *
 * @param {HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | null} element
 * @returns {string}
 */
const inputValue = (element) => {
    let value = "";
    if (element instanceof HTMLInputElement && ["radio"].includes(element.type)) {
        return value;
    }
    if (element) {
        value = element.value;
    }
    return value;
};
/**
 * 入力値を取得する（ラジオボタン）
 *
 * @param {NodeListOf<HTMLInputElement>} elements
 * @returns {string}
 */
const inputValueRadio = (elements) => {
    let value = "";
    if (elements.length > 0) {
        elements.forEach((element) => {
            if (element.type !== "radio") {
                return;
            }
            if (element.checked) {
                value = element.value;
            }
        });
    }
    return value;
};
